/* @generated */
"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
  return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var props = __getOwnPropSymbols(b), i = 0, n = props.length, prop; i < n; i++) {
      prop = props[i];
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = function(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __export = function(target, all) {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = function(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function")
    for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
      key = keys[i];
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: function(k) {
          return from[k];
        }.bind(null, key), enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
  return to;
};
var __toESM = function(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  );
};
var __toCommonJS = function(mod) {
  return __copyProps(__defProp({}, "__esModule", { value: true }), mod);
};

// ../src/buttons/index.ts
var buttons_exports = {};
__export(buttons_exports, {
  Button: function() {
    return Button;
  },
  ButtonBar: function() {
    return ButtonBar;
  },
  IconButton: function() {
    return IconButton;
  },
  SplitButton: function() {
    return SplitButton;
  },
  StylelessButton: function() {
    return StylelessButton;
  },
  ToggleButton: function() {
    return ToggleButton;
  },
  ToggleButtonGroup: function() {
    return ToggleButtonGroup;
  }
});
module.exports = __toCommonJS(buttons_exports);

// ../src/buttons/button/button.tsx
var import_classnames = __toESM(require("classnames"));
var import_focus_visible = require("focus-visible");
var React = __toESM(require("react"));

// ../src/buttons/hooks/useButtonOrAnchor.ts
var useButtonOrAnchor = function(_ref) {
  var href = _ref.href, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, type = _ref.type;
  var buttonProps = {
    type: type
  };
  var TagName = "button";
  if (href) {
    TagName = "a";
    buttonProps.href = href;
    buttonProps["aria-disabled"] = disabled;
  } else {
    buttonProps.disabled = disabled;
  }
  return [TagName, buttonProps];
};

// ../src/buttons/button/button.tsx
var import_dig_icons = require("@dropbox/dig-icons");
var import_assets = require("@dropbox/dig-icons/assets");
var import_progress_indicators = require("@dropbox/dig-components/progress_indicators");

// ../src/_global/sizes.tsx
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
var deprecationMap = [
  // [<modern-value>, <legacy-value>]
  ["medium", "standard"]
];
var getLegacyComponentSize = function(size) {
  var mapping = deprecationMap.find(function(_ref) {
    var _ref2 = _slicedToArray(_ref, 2), newVal = _ref2[0], _deprecatedVal = _ref2[1];
    return size === newVal;
  });
  if (mapping !== void 0) {
    return mapping[1];
  }
  return size;
};
var getMigratedComponentSize = function(size) {
  var mapping = deprecationMap.find(function(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2), _newVal = _ref4[0], deprecatedVal = _ref4[1];
    return size === deprecatedVal;
  });
  if (mapping !== void 0) {
    return mapping[0];
  }
  return size;
};

// ../src/buttons/button/button.tsx
var import_dig_foundations = require("@dropbox/dig-foundations");

// ../src/buttons/button/css/button.css.ts
var import_createRuntimeFn = require("@vanilla-extract/recipes/createRuntimeFn");
var buttonContentVariants = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1f09ta24_21-1-1", variantClassNames: { hasSquaredSize: { true: "dig-1f09ta214_21-1-1" }, hasNoUnderline: { true: "dig-1f09ta215_21-1-1" }, disabled: { true: "dig-1f09ta216_21-1-1" }, isLoading: { true: "dig-1f09ta217_21-1-1" }, variant: { primary: "dig-1f09ta218_21-1-1", opacity: "dig-1f09ta219_21-1-1", filled: "dig-1f09ta21a_21-1-1", outline: "dig-1f09ta21b_21-1-1", borderless: "dig-1f09ta21c_21-1-1", transparent: "dig-1f09ta21d_21-1-1" } }, defaultVariants: {}, compoundVariants: [[{ hasNoUnderline: false, variant: "transparent" }, "dig-1f09ta21e_21-1-1"], [{ hasNoUnderline: true, variant: "transparent" }, "dig-1f09ta21f_21-1-1"], [{ variant: "transparent", isLoading: true }, "dig-1f09ta21g_21-1-1"], [{ variant: "transparent", disabled: true }, "dig-1f09ta21h_21-1-1"]] });
var buttonRootVariants = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1f09ta23_21-1-1", variantClassNames: { size: { small: "dig-t4vtb5c_21-1-1", medium: "dig-t4vtb5d_21-1-1", standard: "dig-t4vtb5d_21-1-1", large: "dig-t4vtb5e_21-1-1", xlarge: "dig-t4vtb5f_21-1-1" }, hasRightMargin: { true: "dig-1f09ta2b_21-1-1" }, hasCollapsedMargins: { true: "dig-1f09ta2c_21-1-1" }, hasSquaredSize: { true: "dig-1f09ta2d_21-1-1" }, disabled: { true: "dig-1f09ta2e_21-1-1" }, fullWidth: { true: "dig-1f09ta2f_21-1-1" }, isLoading: { true: "dig-1f09ta2g_21-1-1" }, hasNoUnderline: { true: "dig-1f09ta2h_21-1-1" }, withDropdownIcon: { true: "dig-1f09ta2i_21-1-1" }, withIconStart: { true: "dig-1f09ta2j_21-1-1" }, withIconEnd: { true: "dig-1f09ta2k_21-1-1" }, focus: { true: "dig-1f09ta20_21-1-1" }, active: { true: "dig-1f09ta21_21-1-1" }, hover: { true: "dig-1f09ta22_21-1-1" }, variant: { primary: "dig-1f09ta2o_21-1-1", opacity: "dig-1f09ta2p_21-1-1", filled: "dig-1f09ta2q_21-1-1", outline: "dig-1f09ta2r_21-1-1", borderless: "dig-1f09ta2s_21-1-1", transparent: "dig-1f09ta2t_21-1-1" } }, defaultVariants: { variant: "primary" }, compoundVariants: [[{ variant: "primary", disabled: true }, "dig-1f09ta2u_21-1-1"], [{ variant: "primary", isLoading: true }, "dig-1f09ta2v_21-1-1"], [{ variant: "filled", disabled: true }, "dig-1f09ta2w_21-1-1"], [{ variant: "opacity", disabled: true, isLoading: false }, "dig-1f09ta2x_21-1-1"], [{ variant: "outline", disabled: true }, "dig-1f09ta2y_21-1-1"], [{ variant: "borderless", disabled: true, isLoading: false }, "dig-1f09ta2z_21-1-1"], [{ variant: "transparent", withIconStart: false, withIconEnd: false }, "dig-1f09ta210_21-1-1"], [{ variant: "transparent", disabled: true }, "dig-1f09ta211_21-1-1"], [{ variant: "transparent", size: "small" }, "dig-1f09ta212_21-1-1"]] });
var buttonSpinner = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1f09ta224_21-1-1", variantClassNames: { isSmall: { true: "dig-1f09ta225_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var buttonToneVariants = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1f09ta21i_21-1-1", variantClassNames: { tone: { destructive: "dig-1f09ta21j_21-1-1", neutral: "dig-1f09ta21k_21-1-1" }, variant: { primary: "dig-t4vtb5g_21-1-1", filled: "dig-t4vtb5m_21-1-1", opacity: "dig-t4vtb5i_21-1-1", outline: "dig-t4vtb5k_21-1-1", transparent: "dig-1f09ta21p_21-1-1", borderless: "dig-t4vtb5o_21-1-1" }, disabled: { false: "dig-1f09ta21r_21-1-1" } }, defaultVariants: {}, compoundVariants: [[{ tone: "neutral", variant: "primary", disabled: false }, "dig-1f09ta21s_21-1-1"], [{ tone: "destructive", variant: "primary", disabled: false }, "dig-1f09ta21t_21-1-1 dig-t4vtb5h_21-1-1"], [{ tone: "neutral", variant: "filled", disabled: false }, "dig-1f09ta21u_21-1-1"], [{ tone: "destructive", variant: "filled", disabled: false }, "dig-1f09ta21v_21-1-1 dig-t4vtb5n_21-1-1"], [{ tone: "neutral", variant: "opacity", disabled: false }, "dig-1f09ta21w_21-1-1"], [{ tone: "destructive", variant: "opacity", disabled: false }, "dig-1f09ta21x_21-1-1 dig-t4vtb5j_21-1-1"], [{ tone: "neutral", variant: "outline", disabled: false }, "dig-1f09ta21y_21-1-1"], [{ tone: "destructive", variant: "outline", disabled: false }, "dig-1f09ta21z_21-1-1 dig-t4vtb5l_21-1-1"], [{ tone: "neutral", variant: "transparent", disabled: false }, "dig-1f09ta220_21-1-1"], [{ tone: "destructive", variant: "transparent", disabled: false }, "dig-1f09ta221_21-1-1"], [{ tone: "neutral", variant: "borderless", disabled: false }, "dig-1f09ta222_21-1-1"], [{ tone: "destructive", variant: "borderless", disabled: false }, "dig-1f09ta223_21-1-1 dig-t4vtb5p_21-1-1"]] });
var iconEndVariants = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1f09ta22c_21-1-1", variantClassNames: { withIconEnd: { true: "dig-1f09ta22d_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var iconStartVariants = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1f09ta22e_21-1-1", variantClassNames: { withIconStart: { true: "dig-1f09ta22f_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var iconVariants = (0, import_createRuntimeFn.createRuntimeFn)({ defaultClassName: "dig-1f09ta226_21-1-1", variantClassNames: { withDropdownIcon: { true: "dig-1f09ta227_21-1-1" }, hasSquaredSize: { true: "dig-1f09ta228_21-1-1" }, variant: { transparent: "dig-1f09ta229_21-1-1" } }, defaultVariants: {}, compoundVariants: [[{ withDropdownIcon: true, variant: "transparent" }, "dig-1f09ta22a_21-1-1"], [{ hasSquaredSize: true, withDropdownIcon: true }, "dig-1f09ta22b_21-1-1"]] });

// ../src/_global/constants.ts
var buttonDataAttributeName = "data-dig-button";
var buttonDataSelector = "[".concat(buttonDataAttributeName, "]");
var buttonContentDataAttributeName = "data-dig-button-content";
var buttonContentDataSelector = "[".concat(buttonContentDataAttributeName, "]");
var splitButtonDataAttributeName = "data-dig-split-button";
var splitButtonDataSelector = "[".concat(splitButtonDataAttributeName, "]");
var iconButtonDataAttributeName = "data-dig-icon-button";
var iconButtonDataSelector = "[".concat(iconButtonDataAttributeName, "]");

// ../src/buttons/button/button.tsx
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var _excluded = ["children", "className", "variant", "inverse", "size", "withDropdownIcon", "withIconLeft", "withIconStart", "withIconEnd", "hasNoUnderline", "href", "fullWidth", "isLoading", "disabled", "_hasRightMargin", "_hasCollapsedMargins", "_hasSquaredSize", "type", "_pseudoClass", "tone"];
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray2(arr, i) {
  return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i) || _unsupportedIterableToArray2(arr, i) || _nonIterableRest2();
}
function _nonIterableRest2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray2(o, minLen);
}
function _arrayLikeToArray2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit2(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles2(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function getIconSize(buttonSize) {
  var calculatedButtonSize = buttonSize || "medium";
  switch (calculatedButtonSize) {
    case "small":
      return "small";
    default:
      return "medium";
  }
}
var Button = React.forwardRef(function(_ref, ref) {
  var children = _ref.children, className = _ref.className, variant = _ref.variant, _ref$inverse = _ref.inverse, inverse = _ref$inverse === void 0 ? false : _ref$inverse, _ref$size = _ref.size, _size = _ref$size === void 0 ? "medium" : _ref$size, _ref$withDropdownIcon = _ref.withDropdownIcon, withDropdownIcon = _ref$withDropdownIcon === void 0 ? false : _ref$withDropdownIcon, _withIconLeft = _ref.withIconLeft, _withIconStart = _ref.withIconStart, withIconEnd = _ref.withIconEnd, _ref$hasNoUnderline = _ref.hasNoUnderline, hasNoUnderline = _ref$hasNoUnderline === void 0 ? false : _ref$hasNoUnderline, href = _ref.href, _ref$fullWidth = _ref.fullWidth, fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? isLoading : _ref$disabled, _hasRightMargin = _ref._hasRightMargin, _hasCollapsedMargins = _ref._hasCollapsedMargins, _ref$_hasSquaredSize = _ref._hasSquaredSize, _hasSquaredSize = _ref$_hasSquaredSize === void 0 ? false : _ref$_hasSquaredSize, type = _ref.type, _ref$_pseudoClass = _ref._pseudoClass, _pseudoClass = _ref$_pseudoClass === void 0 ? [] : _ref$_pseudoClass, _ref$tone = _ref.tone, tone = _ref$tone === void 0 ? "neutral" : _ref$tone, rest = _objectWithoutProperties(_ref, _excluded);
  var size = getMigratedComponentSize(_size);
  var withIconStart = _withIconStart || _withIconLeft;
  if (fullWidth) {
    if (variant === "transparent") {
      throw new Error("`fullWidth` can only be applied to non-transparent variants.");
    }
    if (size !== "large" && size !== "xlarge") {
      throw new Error('`fullWidth` can only be applied to "large" and "xlarge" sizes.');
    }
  }
  var _useButtonOrAnchor = useButtonOrAnchor({
    href: href,
    disabled: disabled || isLoading,
    type: type
  }), _useButtonOrAnchor2 = _slicedToArray2(_useButtonOrAnchor, 2), TagName = _useButtonOrAnchor2[0], buttonProps = _useButtonOrAnchor2[1];
  var inverseClassName = (0, import_dig_foundations.useTheme)().getInverseProps().className;
  var cls = (0, import_classnames.default)("dig-Button", "dig-Button--".concat(variant), "dig-Button--".concat(getLegacyComponentSize(size)), _defineProperty(_defineProperty({
    "dig-Button--medium": size === "medium",
    "dig-Button--fullWidth": fullWidth,
    "dig-Button--isLoading": isLoading,
    "dig-Button--withDropdownIcon": withDropdownIcon,
    "dig-Button--withIconStart": withIconStart,
    "dig-Button--withIconEnd": withIconEnd,
    "dig-Button--hasNoUnderline": variant === "transparent" && hasNoUnderline,
    "dig-Button--hasRightMargin": _hasRightMargin,
    "dig-Button--hasCollapsedMargins": _hasCollapsedMargins,
    "dig-Button--hasSquaredSize": _hasSquaredSize,
    "dig-Button--hover": _pseudoClass.includes("hover"),
    "dig-Button--active": _pseudoClass.includes("active"),
    "dig-Button--focus": _pseudoClass.includes("focus")
  }, "dig-Button-tone--".concat(tone), tone), inverseClassName, inverse), buttonRootVariants({
    variant: variant,
    size: size,
    hasRightMargin: _hasRightMargin,
    hasCollapsedMargins: _hasCollapsedMargins,
    hasSquaredSize: _hasSquaredSize,
    disabled: disabled,
    fullWidth: fullWidth,
    isLoading: isLoading,
    hasNoUnderline: variant === "transparent" && hasNoUnderline,
    withDropdownIcon: withDropdownIcon,
    withIconStart: !!withIconStart,
    withIconEnd: !!withIconEnd,
    hover: _pseudoClass.includes("hover"),
    active: _pseudoClass.includes("active"),
    focus: _pseudoClass.includes("focus")
  }), buttonToneVariants({
    variant: variant,
    tone: tone,
    disabled: disabled || isLoading
  }), className);
  var dataAttrs = _defineProperty({}, buttonDataAttributeName, true);
  var contentDataAttrs = _defineProperty({}, buttonContentDataAttributeName, true);
  return /* @__PURE__ */ React.createElement(TagName, __spreadValues(__spreadValues(__spreadProps(__spreadValues({ className: cls }, dataAttrs), { ref: ref }), buttonProps), rest), /* @__PURE__ */ React.createElement("span", __spreadValues({ className: (0, import_classnames.default)("dig-Button-content", buttonContentVariants({
    variant: variant,
    hasSquaredSize: _hasSquaredSize,
    disabled: disabled,
    isLoading: isLoading,
    hasNoUnderline: variant === "transparent" && hasNoUnderline
  })) }, contentDataAttrs), withIconStart && /* @__PURE__ */ React.createElement("span", { className: (0, import_classnames.default)("dig-Button-icon-start-wrapper", iconStartVariants({
    withIconStart: !!withIconStart
  })) }, /* @__PURE__ */ React.createElement(import_dig_icons.IconContext.Provider, { value: {
    UIIconOverrides: {
      size: getIconSize(size),
      isOpticallyAligned: true
    }
  } }, withIconStart)), children, withIconEnd && /* @__PURE__ */ React.createElement("span", { className: (0, import_classnames.default)("dig-Button-icon-end-wrapper", iconEndVariants({
    withIconEnd: !!withIconEnd
  })) }, /* @__PURE__ */ React.createElement(import_dig_icons.IconContext.Provider, { value: {
    UIIconOverrides: {
      size: getIconSize(size),
      isOpticallyAligned: true
    }
  } }, withIconEnd)), withDropdownIcon && /* @__PURE__ */ React.createElement(import_dig_icons.UIIcon, { className: (0, import_classnames.default)("dig-Button-icon", iconVariants({
    withDropdownIcon: withDropdownIcon,
    hasSquaredSize: _hasSquaredSize,
    variant: variant === "transparent" ? "transparent" : void 0
  })), src: import_assets.ChevronDownLine, size: "small", "data-testid": "digButtonDropdownIcon", isOpticallyAligned: true })), isLoading && /* @__PURE__ */ React.createElement("span", { className: (0, import_classnames.default)("dig-Button-spinner", buttonSpinner({
    isSmall: size === "small"
  })), "data-testid": "digButtonSpinner" }, /* @__PURE__ */ React.createElement(
    import_progress_indicators.Spinner,
    {
      monochromatic: true,
      hasOpaqueTrack: variant === "primary",
      size: "xsmall"
    }
  )));
});
Button.displayName = "Button";

// ../src/buttons/icon_button/index.css.ts
var import_createRuntimeFn2 = require("@vanilla-extract/recipes/createRuntimeFn");
var iconButton = (0, import_createRuntimeFn2.createRuntimeFn)({ defaultClassName: "dig-4apwuh2_21-1-1 dig-4apwuh1_21-1-1", variantClassNames: { variant: { filled: "dig-4apwuh3_21-1-1", outline: "dig-4apwuh4_21-1-1", opacity: "dig-4apwuh5_21-1-1", transparent: "dig-4apwuh6_21-1-1", borderless: "dig-4apwuh7_21-1-1" }, size: { small: "dig-4apwuh8_21-1-1", medium: "dig-4apwuh9_21-1-1", standard: "dig-4apwuha_21-1-1", large: "dig-4apwuhb_21-1-1", xlarge: "dig-4apwuhc_21-1-1" }, withDropdownIcon: { true: "dig-4apwuhd_21-1-1" }, shape: { circular: "dig-4apwuhe_21-1-1", standard: "dig-4apwuhf_21-1-1" }, hover: { true: "dig-4apwuhg_21-1-1" }, active: { true: "dig-4apwuhh_21-1-1" }, focus: { true: "dig-4apwuhi_21-1-1" } }, defaultVariants: {}, compoundVariants: [[{ hover: true, active: true }, "dig-4apwuhj_21-1-1"]] });
var iconButtonContent = "dig-4apwuh1k_21-1-1";
var iconButtonToneForcedStates = (0, import_createRuntimeFn2.createRuntimeFn)({ defaultClassName: "dig-4apwuhw_21-1-1", variantClassNames: { tone: { neutral: "dig-4apwuhx_21-1-1", destructive: "dig-4apwuhy_21-1-1" }, variant: { filled: "dig-4apwuhz_21-1-1", outline: "dig-4apwuh10_21-1-1", opacity: "dig-4apwuh11_21-1-1", transparent: "dig-4apwuh12_21-1-1", borderless: "dig-4apwuh13_21-1-1" }, hover: { true: "dig-4apwuh14_21-1-1" }, active: { true: "dig-4apwuh15_21-1-1" }, focus: { true: "dig-4apwuh16_21-1-1" } }, defaultVariants: {}, compoundVariants: [[{ variant: "outline", focus: true }, "dig-4apwuh17_21-1-1"], [{ variant: "filled", focus: true }, "dig-4apwuh18_21-1-1"], [{ hover: true, active: true }, "dig-4apwuh19_21-1-1"], [{ tone: "destructive", variant: "filled", hover: true }, "dig-4apwuh1a_21-1-1"], [{ tone: "destructive", variant: "filled", active: true }, "dig-4apwuh1b_21-1-1"], [{ tone: "destructive", variant: "opacity", hover: true }, "dig-4apwuh1c_21-1-1"], [{ tone: "destructive", variant: "opacity", active: true }, "dig-4apwuh1d_21-1-1"], [{ tone: "destructive", variant: "opacity", focus: true }, "dig-4apwuh1e_21-1-1"], [{ tone: "destructive", variant: "outline", focus: true }, "dig-4apwuh1f_21-1-1"], [{ tone: "destructive", variant: "outline", hover: true }, "dig-4apwuh1g_21-1-1"], [{ tone: "destructive", variant: "outline", active: true }, "dig-4apwuh1h_21-1-1"], [{ tone: "destructive", variant: "borderless", hover: true }, "dig-4apwuh1i_21-1-1"], [{ tone: "destructive", variant: "borderless", active: true }, "dig-4apwuh1j_21-1-1"]] });
var iconButtonTones = (0, import_createRuntimeFn2.createRuntimeFn)({ defaultClassName: "dig-4apwuhk_21-1-1", variantClassNames: { tone: { neutral: "dig-4apwuhl_21-1-1", destructive: "dig-4apwuhm_21-1-1" }, variant: { filled: "dig-4apwuhn_21-1-1", outline: "dig-4apwuho_21-1-1", opacity: "dig-4apwuhp_21-1-1", transparent: "dig-4apwuhq_21-1-1", borderless: "dig-4apwuhr_21-1-1" } }, defaultVariants: {}, compoundVariants: [[{ tone: "destructive", variant: "filled" }, "dig-4apwuhs_21-1-1"], [{ tone: "destructive", variant: "opacity" }, "dig-4apwuht_21-1-1"], [{ tone: "destructive", variant: "outline" }, "dig-4apwuhu_21-1-1"], [{ tone: "destructive", variant: "borderless" }, "dig-4apwuhv_21-1-1"]] });

// ../src/buttons/icon_button/icon_button.tsx
var import_classnames2 = __toESM(require("classnames"));
var import_focus_visible2 = require("focus-visible");
var React3 = __toESM(require("react"));
var import_dig_icons2 = require("@dropbox/dig-icons");
var import_assets2 = require("@dropbox/dig-icons/assets");

// ../src/utils.ts
var React2 = __toESM(require("react"));
var weakInvariant = function(condition, message) {
  if (!condition) {
    console.error("dig-components:", message);
  }
};

// ../src/buttons/icon_button/icon_button.tsx
var import_dig_foundations2 = require("@dropbox/dig-foundations");
function _typeof2(o) {
  "@babel/helpers - typeof";
  return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof2(o);
}
var _excluded2 = ["children", "className", "disabled", "variant", "inverse", "isRounded", "shape", "size", "withDropdownIcon", "href", "type", "_pseudoClass", "tone"];
function _defineProperty2(obj, key, value) {
  key = _toPropertyKey2(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey2(t) {
  var i = _toPrimitive2(t, "string");
  return "symbol" == _typeof2(i) ? i : String(i);
}
function _toPrimitive2(t, r) {
  if ("object" != _typeof2(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof2(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray3(arr, i) {
  return _arrayWithHoles3(arr) || _iterableToArrayLimit3(arr, i) || _unsupportedIterableToArray3(arr, i) || _nonIterableRest3();
}
function _nonIterableRest3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray3(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray3(o, minLen);
}
function _arrayLikeToArray3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit3(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles3(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _objectWithoutProperties2(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose2(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function getIconSize2(buttonSize) {
  var calculatedButtonSize = buttonSize || "medium";
  switch (calculatedButtonSize) {
    case "small":
      return "small";
    case "medium":
      return "medium";
    case "large":
    case "xlarge":
      return "large";
    default:
      return "medium";
  }
}
var IconButton = React3.forwardRef(function(_ref, ref) {
  var children = _ref.children, className = _ref.className, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? false : _ref$disabled, variant = _ref.variant, _ref$inverse = _ref.inverse, inverse = _ref$inverse === void 0 ? false : _ref$inverse, isRounded = _ref.isRounded, _shape = _ref.shape, _ref$size = _ref.size, _size = _ref$size === void 0 ? "medium" : _ref$size, _ref$withDropdownIcon = _ref.withDropdownIcon, withDropdownIcon = _ref$withDropdownIcon === void 0 ? false : _ref$withDropdownIcon, href = _ref.href, type = _ref.type, _ref$_pseudoClass = _ref._pseudoClass, _pseudoClass = _ref$_pseudoClass === void 0 ? [] : _ref$_pseudoClass, _ref$tone = _ref.tone, tone = _ref$tone === void 0 ? "neutral" : _ref$tone, rest = _objectWithoutProperties2(_ref, _excluded2);
  var _useButtonOrAnchor = useButtonOrAnchor({
    href: href,
    disabled: disabled,
    type: type
  }), _useButtonOrAnchor2 = _slicedToArray3(_useButtonOrAnchor, 2), TagName = _useButtonOrAnchor2[0], buttonProps = _useButtonOrAnchor2[1];
  var size = getMigratedComponentSize(_size);
  var shape = _shape ? _shape : isRounded === true ? "circular" : "standard";
  var inverseClassName = (0, import_dig_foundations2.useTheme)().getInverseProps().className;
  weakInvariant(!(withDropdownIcon && shape === "circular"), "`withDropdownIcon` only applies to non-circular icon buttons.");
  var cls = (0, import_classnames2.default)("dig-IconButton", "dig-IconButton--".concat(variant), "dig-IconButton--".concat(getLegacyComponentSize(size)), _defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2(_defineProperty2({
    "dig-IconButton--medium": size === "medium"
  }, inverseClassName, inverse), "dig-IconButton--circular", shape === "circular"), "dig-IconButton--withDropdownIcon", withDropdownIcon && shape !== "circular"), "dig-IconButton--hover", _pseudoClass.includes("hover")), "dig-IconButton--active", _pseudoClass.includes("active")), "dig-IconButton--focus", _pseudoClass.includes("focus")), "dig-IconButton-tone--".concat(tone), tone), className, iconButton({
    variant: variant,
    size: size,
    shape: shape,
    withDropdownIcon: withDropdownIcon && shape !== "circular"
  }), disabled === false ? iconButtonTones({
    tone: tone,
    variant: variant
  }) : "", disabled === false ? iconButtonToneForcedStates({
    tone: tone,
    variant: variant,
    active: _pseudoClass.includes("active"),
    hover: _pseudoClass.includes("hover"),
    focus: _pseudoClass.includes("focus")
  }) : "");
  var dataAttrs = _defineProperty2(_defineProperty2({}, buttonDataAttributeName, true), iconButtonDataAttributeName, true);
  return /* @__PURE__ */ React3.createElement(TagName, __spreadValues(__spreadValues(__spreadProps(__spreadValues({ className: cls }, dataAttrs), { ref: ref }), buttonProps), rest), /* @__PURE__ */ React3.createElement("span", { className: (0, import_classnames2.default)("dig-IconButton-content", iconButtonContent) }, /* @__PURE__ */ React3.createElement(import_dig_icons2.IconContext.Provider, { value: {
    UIIconOverrides: {
      size: getIconSize2(size)
    }
  } }, children), withDropdownIcon && shape !== "circular" && // UIIcon here has no aria-label which is fine because this is just an additional visual
  // indicator and is not a standalone button on it's own (ie: the icon is not focusable
  // by itself).
  /* @__PURE__ */ React3.createElement(import_dig_icons2.UIIcon, { src: import_assets2.ChevronDownLine, size: "small", "data-testid": "digIconButtonDropdownIcon" })));
});
IconButton.displayName = "IconButton";

// ../src/buttons/split_button/index.css.ts
var dropdownButton = { small: "dig-9n0h762_21-1-1", medium: "dig-9n0h763_21-1-1", large: "dig-9n0h764_21-1-1", xlarge: "dig-9n0h765_21-1-1" };
var mainButton = { small: "dig-9n0h766_21-1-1", medium: "dig-9n0h767_21-1-1", large: "dig-9n0h768_21-1-1", xlarge: "dig-9n0h769_21-1-1" };
var splitButton = "dig-9n0h760_21-1-1";
var splitButtonFullWidth = "dig-9n0h761_21-1-1";

// ../src/buttons/split_button/split_button.tsx
var import_classnames3 = __toESM(require("classnames"));
var import_focus_visible3 = require("focus-visible");
var React4 = __toESM(require("react"));
var import_dig_foundations3 = require("@dropbox/dig-foundations");
function _typeof3(o) {
  "@babel/helpers - typeof";
  return _typeof3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof3(o);
}
var _excluded3 = ["className", "children", "renderMenu", "variant", "inverse", "size", "fullWidth", "isLoading", "disabled", "_pseudoClass", "withIconStart"];
function _defineProperty3(obj, key, value) {
  key = _toPropertyKey3(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey3(t) {
  var i = _toPrimitive3(t, "string");
  return "symbol" == _typeof3(i) ? i : String(i);
}
function _toPrimitive3(t, r) {
  if ("object" != _typeof3(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof3(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties3(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose3(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var SplitButton = React4.forwardRef(function(_ref, ref) {
  var className = _ref.className, children = _ref.children, renderMenu = _ref.renderMenu, variant = _ref.variant, _ref$inverse = _ref.inverse, inverse = _ref$inverse === void 0 ? false : _ref$inverse, _ref$size = _ref.size, _size = _ref$size === void 0 ? "medium" : _ref$size, _ref$fullWidth = _ref.fullWidth, fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, _ref$disabled = _ref.disabled, disabled = _ref$disabled === void 0 ? isLoading : _ref$disabled, _ref$_pseudoClass = _ref._pseudoClass, _pseudoClass = _ref$_pseudoClass === void 0 ? [] : _ref$_pseudoClass, withIconStart = _ref.withIconStart, rest = _objectWithoutProperties3(_ref, _excluded3);
  var size = getMigratedComponentSize(_size);
  var inverseClassName = (0, import_dig_foundations3.useTheme)().getInverseProps().className;
  var cls = (0, import_classnames3.default)("dig-SplitButton", "".concat(splitButton), "dig-SplitButton--".concat(variant), "dig-SplitButton--".concat(getLegacyComponentSize(size)), _defineProperty3(_defineProperty3({
    "dig-SplitButton--medium": size === "medium",
    "dig-SplitButton--fullWidth": fullWidth
  }, "".concat(splitButtonFullWidth), fullWidth), inverseClassName, inverse), className);
  var options = {
    buttonProps: {
      variant: variant,
      size: size,
      inverse: inverse,
      disabled: disabled || isLoading,
      className: (0, import_classnames3.default)("dig-SplitButton-menu-button", dropdownButton[size]),
      withDropdownIcon: true,
      _hasSquaredSize: true
    }
  };
  var dataAttrs = _defineProperty3({}, splitButtonDataAttributeName, true);
  return /* @__PURE__ */ React4.createElement("span", __spreadValues({ role: "group", className: cls }, dataAttrs), /* @__PURE__ */ React4.createElement(Button, __spreadProps(__spreadValues({ ref: ref, className: (0, import_classnames3.default)("dig-SplitButton-button", mainButton[size]), variant: variant, size: size, isLoading: isLoading, disabled: disabled, withIconStart: withIconStart, _pseudoClass: _pseudoClass }, rest), { _hasRightMargin: variant === "primary" || variant === "opacity", _hasCollapsedMargins: variant === "outline" || variant === "filled" }), children), renderMenu(options));
});
SplitButton.displayName = "SplitButton";

// ../src/buttons/styleless_button/styleless_button.tsx
var import_classnames4 = __toESM(require("classnames"));
var React5 = __toESM(require("react"));

// ../src/buttons/styleless_button/index.css.ts
var import_createRuntimeFn3 = require("@vanilla-extract/recipes/createRuntimeFn");
var stylelessButton = (0, import_createRuntimeFn3.createRuntimeFn)({ defaultClassName: "dig-33owqk1_21-1-1 dig-33owqk0_21-1-1", variantClassNames: { circular: { true: "dig-33owqk2_21-1-1" }, cursor: { pointer: "dig-33owqk3_21-1-1", "default": "dig-33owqk4_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var stylelessButtonContent = "dig-33owqk5_21-1-1";

// ../src/buttons/styleless_button/styleless_button.tsx
var import_focus_visible4 = require("focus-visible");
var _excluded4 = ["cursor", "circular", "children", "className"];
function _objectWithoutProperties4(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose4(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose4(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var StylelessButton = React5.forwardRef(function(_ref, ref) {
  var _ref$cursor = _ref.cursor, cursor = _ref$cursor === void 0 ? "default" : _ref$cursor, _ref$circular = _ref.circular, circular = _ref$circular === void 0 ? false : _ref$circular, children = _ref.children, className = _ref.className, rest = _objectWithoutProperties4(_ref, _excluded4);
  var cls = (0, import_classnames4.default)("dig-StylelessButton", className, {
    "dig-StylelessButton--pointer": cursor === "pointer",
    "dig-StylelessButton--circular": circular
  }, stylelessButton({
    circular: circular,
    cursor: cursor
  }));
  return /* @__PURE__ */ React5.createElement("button", __spreadValues({ className: cls, ref: ref }, rest), /* @__PURE__ */ React5.createElement("span", { className: (0, import_classnames4.default)("dig-StylelessButton-content", stylelessButtonContent) }, children));
});
StylelessButton.displayName = "StylelessButton";

// ../src/buttons/button_bar/button_bar.tsx
var import_classnames6 = __toESM(require("classnames"));
var import_focus_visible5 = require("focus-visible");
var React7 = __toESM(require("react"));
var import_dig_icons3 = require("@dropbox/dig-icons");

// ../src/buttons/button_bar/button_bar_overflow.tsx
var React6 = __toESM(require("react"));
var import_menu = require("@dropbox/dig-components/menu");
var import_classnames5 = __toESM(require("classnames"));

// ../src/buttons/button_bar/styles.css.ts
var import_createRuntimeFn4 = require("@vanilla-extract/recipes/createRuntimeFn");
var button = "dig-1iro7am7_21-1-1";
var buttonBarVariants = (0, import_createRuntimeFn4.createRuntimeFn)({ defaultClassName: "dig-1iro7am0_21-1-1", variantClassNames: { variant: { primary: "dig-1iro7am9_21-1-1", opacity: "dig-1iro7ama_21-1-1", filled: "dig-1iro7amb_21-1-1", outline: "dig-1iro7amc_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var menu = "dig-1iro7am1_21-1-1";
var menuTriggerVariants = (0, import_createRuntimeFn4.createRuntimeFn)({ defaultClassName: "dig-1iro7am2_21-1-1", variantClassNames: { size: { small: "dig-1iro7ame_21-1-1", medium: "dig-1iro7amf_21-1-1", standard: "dig-1iro7amg_21-1-1", large: "dig-1iro7amh_21-1-1", xlarge: "dig-1iro7ami_21-1-1" } }, defaultVariants: {}, compoundVariants: [] });
var overflowStyles = { root: "dig-1iro7am3_21-1-1", content: "dig-1iro7am4_21-1-1", shadow: "dig-1iro7am5_21-1-1", buttons: "dig-1iro7am6_21-1-1" };

// ../src/buttons/button_bar/button_bar_overflow.tsx
function _typeof4(o) {
  "@babel/helpers - typeof";
  return _typeof4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof4(o);
}
function _slicedToArray4(arr, i) {
  return _arrayWithHoles4(arr) || _iterableToArrayLimit4(arr, i) || _unsupportedIterableToArray4(arr, i) || _nonIterableRest4();
}
function _nonIterableRest4() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray4(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray4(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray4(o, minLen);
}
function _arrayLikeToArray4(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit4(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles4(arr) {
  if (Array.isArray(arr))
    return arr;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty4(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty4(obj, key, value) {
  key = _toPropertyKey4(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey4(t) {
  var i = _toPrimitive4(t, "string");
  return "symbol" == _typeof4(i) ? i : String(i);
}
function _toPrimitive4(t, r) {
  if ("object" != _typeof4(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof4(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var BUTTON_BAR_SHADOW_BUTTON_ID_PREFIX = "digButtonBarShadow-";
var getMenuItemPropsFromButton = function(buttonProps) {
  return _objectSpread({
    id: buttonProps.id,
    children: buttonProps.children,
    disabled: buttonProps.disabled,
    onClick: buttonProps.onClick,
    href: buttonProps.href,
    value: buttonProps.href,
    "aria-label": buttonProps["aria-label"],
    withLeftAccessory: buttonProps.withIconStart || buttonProps.withIconLeft,
    withRightAccessory: buttonProps.withIconEnd
  }, buttonProps.menuItemProps);
};
var ButtonBarOverflow = function(_ref) {
  var children = _ref.children, menuTrigger = _ref.menuTrigger;
  var _React$useState = React6.useState(/* @__PURE__ */ new Map()), _React$useState2 = _slicedToArray4(_React$useState, 2), visibilityMap = _React$useState2[0], setVisibilityMap = _React$useState2[1];
  var shadowRef = React6.useRef(null);
  var observer = React6.useRef();
  var hasOverflowMenu = !Array.from(visibilityMap.values()).every(function(item) {
    return item;
  });
  React6.useEffect(function() {
    var handleIntersection = function(entries) {
      entries.forEach(function(entry) {
        var shadowId = entry.target.id;
        setVisibilityMap(function(prev) {
          var newMap = new Map(prev);
          newMap.set(shadowId, entry.isIntersecting);
          return newMap;
        });
      });
    };
    if (window.IntersectionObserver) {
      observer.current = new IntersectionObserver(handleIntersection, {
        root: shadowRef.current,
        threshold: 1
      });
      if (shadowRef.current) {
        Array.from(shadowRef.current.children).forEach(function(child) {
          if (observer.current)
            observer.current.observe(child);
        });
      }
    } else {
      if (shadowRef.current) {
        Array.from(shadowRef.current.children).forEach(function(child, index) {
          setVisibilityMap(function(prev) {
            var newMap = new Map(prev);
            newMap.set(child.id, index === 0);
            return newMap;
          });
        });
      }
    }
    return function() {
      if (observer.current) {
        observer.current.disconnect();
        observer.current = void 0;
      }
    };
  }, []);
  return /* @__PURE__ */ React6.createElement("div", { className: (0, import_classnames5.default)("dig-ButtonBar-overflow", overflowStyles.root) }, /* @__PURE__ */ React6.createElement("div", { className: (0, import_classnames5.default)("dig-ButtonBar-overflow-content", overflowStyles.content) }, React6.Children.map(children, function(child) {
    if (React6.isValidElement(child) && visibilityMap.get("".concat(BUTTON_BAR_SHADOW_BUTTON_ID_PREFIX).concat(child.props.id))) {
      return child;
    }
  }), hasOverflowMenu && /* @__PURE__ */ React6.createElement(import_menu.Menu.Wrapper, { className: (0, import_classnames5.default)("dig-ButtonBar-menu", menu) }, function(_ref2) {
    var getContentProps = _ref2.getContentProps, getTriggerProps = _ref2.getTriggerProps;
    return /* @__PURE__ */ React6.createElement(React6.Fragment, null, React6.isValidElement(menuTrigger) && React6.cloneElement(menuTrigger, _objectSpread({}, getTriggerProps())), /* @__PURE__ */ React6.createElement(import_menu.Menu.Content, __spreadValues({}, getContentProps()), /* @__PURE__ */ React6.createElement(import_menu.Menu.Segment, null, React6.Children.map(children, function(child) {
      if (React6.isValidElement(child)) {
        var id = "".concat(BUTTON_BAR_SHADOW_BUTTON_ID_PREFIX).concat(child.props.id);
        if (!visibilityMap.get(id)) {
          return /* @__PURE__ */ React6.createElement(import_menu.Menu.ActionItem, __spreadValues({ key: child.props.id }, getMenuItemPropsFromButton(child.props)), child.props.children);
        }
      }
    }))));
  })), /* @__PURE__ */ React6.createElement("div", { className: (0, import_classnames5.default)("dig-ButtonBar-overflow-content dig-ButtonBar-overflow-content-shadow", overflowStyles.content, overflowStyles.shadow), "aria-hidden": "true" }, /* @__PURE__ */ React6.createElement("div", { className: (0, import_classnames5.default)("dig-ButtonBar-overflow-buttons", overflowStyles.buttons), ref: shadowRef }, React6.Children.map(children, function(child) {
    if (React6.isValidElement(child)) {
      return React6.cloneElement(child, {
        id: "".concat(BUTTON_BAR_SHADOW_BUTTON_ID_PREFIX).concat(child.props.id),
        "aria-hidden": true,
        tabIndex: -1
      });
    }
  })), hasOverflowMenu && /* @__PURE__ */ React6.createElement(import_menu.Menu.Wrapper, null, function() {
    return /* @__PURE__ */ React6.createElement(React6.Fragment, null, React6.isValidElement(menuTrigger) && React6.cloneElement(menuTrigger, {
      // propagate the data-testid is to make the difference between the triggers in visible part and shadow part.
      // Otherwise, those two trigger will has the same data-testid and it's hard to test
      "data-testid": "".concat(BUTTON_BAR_SHADOW_BUTTON_ID_PREFIX).concat(menuTrigger.props["data-testid"])
    }));
  })));
};
ButtonBarOverflow.displayName = "ButtonBarOverflow";

// ../src/buttons/button_bar/button_bar.tsx
var import_assets3 = require("@dropbox/dig-icons/assets");
function _typeof5(o) {
  "@babel/helpers - typeof";
  return _typeof5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof5(o);
}
var _excluded5 = ["variant", "size", "disabled"];
var _excluded22 = ["children", "className", "variant", "disabled", "size"];
var _excluded32 = ["children", "className", "variant", "size", "disabled", "buttonGroupProps"];
function ownKeys2(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys2(Object(t), true).forEach(function(r2) {
      _defineProperty5(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys2(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty5(obj, key, value) {
  key = _toPropertyKey5(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey5(t) {
  var i = _toPrimitive5(t, "string");
  return "symbol" == _typeof5(i) ? i : String(i);
}
function _toPrimitive5(t, r) {
  if ("object" != _typeof5(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof5(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties5(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose5(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose5(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var MenuTrigger = React7.forwardRef(function(_ref, ref) {
  var variant = _ref.variant, _ref$size = _ref.size, size = _ref$size === void 0 ? "medium" : _ref$size, disabled = _ref.disabled, rest = _objectWithoutProperties5(_ref, _excluded5);
  var cls = (0, import_classnames6.default)("dig-ButtonBar-menu-trigger", "dig-ButtonBar-menu-trigger--".concat(size), menuTriggerVariants({
    size: size
  }));
  return /* @__PURE__ */ React7.createElement(Button, __spreadValues({ className: cls, variant: variant, size: size, disabled: disabled, ref: ref, "data-testid": "digButtonBarMenuTrigger" }, rest), /* @__PURE__ */ React7.createElement(import_dig_icons3.UIIcon, { size: "small", src: import_assets3.MoreHorizontalLine }));
});
var ButtonBarButton = React7.forwardRef(function(_ref2, ref) {
  var children = _ref2.children, className = _ref2.className, variant = _ref2.variant, _ref2$disabled = _ref2.disabled, disabled = _ref2$disabled === void 0 ? false : _ref2$disabled, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? "medium" : _ref2$size, rest = _objectWithoutProperties5(_ref2, _excluded22);
  var buttonCls = (0, import_classnames6.default)("dig-ButtonBar-button", button, className);
  var restWithoutMenuItemProps = _objectSpread2({}, rest);
  delete restWithoutMenuItemProps["menuItemProps"];
  return /* @__PURE__ */ React7.createElement(Button, __spreadProps(__spreadValues({ id: rest.id }, restWithoutMenuItemProps), { className: buttonCls, variant: variant, size: size, disabled: disabled, ref: ref }), children);
});
var ButtonBar = React7.forwardRef(function(_ref3, ref) {
  var _children = _ref3.children, className = _ref3.className, variant = _ref3.variant, _ref3$size = _ref3.size, size = _ref3$size === void 0 ? "medium" : _ref3$size, _ref3$disabled = _ref3.disabled, disabled = _ref3$disabled === void 0 ? false : _ref3$disabled, buttonGroupProps = _ref3.buttonGroupProps, rest = _objectWithoutProperties5(_ref3, _excluded32);
  var cls = (0, import_classnames6.default)("dig-ButtonBar", "dig-ButtonBar--".concat(variant), {
    "dig-ButtonBar--disabled": disabled
  }, buttonBarVariants({
    variant: variant
  }), className);
  return /* @__PURE__ */ React7.createElement("div", __spreadValues({ className: cls, ref: ref }, rest), /* @__PURE__ */ React7.createElement(ButtonBarOverflow, { menuTrigger: /* @__PURE__ */ React7.createElement(MenuTrigger, { variant: variant, size: size, disabled: disabled }) }, buttonGroupProps.map(function(props) {
    return /* @__PURE__ */ React7.createElement(ButtonBarButton, __spreadProps(__spreadValues({ key: props.id }, props), { variant: variant, size: size, disabled: disabled || props.disabled, ref: props.ref }), props.children);
  })));
});
ButtonBar.displayName = "ButtonBar";

// ../src/buttons/toggle_button/context.tsx
var React8 = __toESM(require("react"));
var ToggleButtonContext = React8.createContext({
  variant: "filled",
  size: "medium",
  shape: "standard",
  selected: null,
  // Default to false so ToggleButton knows we're not in a group
  isInsideGroup: false
});

// ../src/_global/boxConverters.ts
var tshirtPropSizeMap = /* @__PURE__ */ function(tshirtPropSizeMap2) {
  tshirtPropSizeMap2["xsmall"] = "XSmall";
  tshirtPropSizeMap2["small"] = "Small";
  tshirtPropSizeMap2["medium"] = "Medium";
  tshirtPropSizeMap2["large"] = "Large";
  tshirtPropSizeMap2["xlarge"] = "XLarge";
  return tshirtPropSizeMap2;
}(tshirtPropSizeMap || {});
function getSizeString(pre, size) {
  return "".concat(pre, " ").concat(tshirtPropSizeMap[size]);
}

// ../src/buttons/toggle_button/toggle_button.tsx
var import_dig_foundations5 = require("@dropbox/dig-foundations");

// ../src/_global/components/internal_box.tsx
var React9 = __toESM(require("react"));
var import_dig_foundations4 = require("@dropbox/dig-foundations");
var _excluded6 = ["children", "className", "_dangerouslySetClassName", "sx"];
function _objectWithoutProperties6(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose6(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose6(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var InternalBox = function(_ref) {
  var children = _ref.children, _cls = _ref.className, _dangerouslySetClassName = _ref._dangerouslySetClassName, sx = _ref.sx, rest = _objectWithoutProperties6(_ref, _excluded6);
  return (
    // For now we pass through `sx` as it doesn't exist on `Box` yet, but an optimization to this will come soon, which will add this prop...
    /* @__PURE__ */ React9.createElement(import_dig_foundations4.Box, __spreadProps(__spreadValues(__spreadValues({}, sx), rest), { className: _dangerouslySetClassName }), children)
  );
};

// ../src/buttons/toggle_button/toggle_button.tsx
var import_dig_icons4 = require("@dropbox/dig-icons");

// ../src/buttons/toggle_button/index.css.ts
var import_createRuntimeFn5 = require("@vanilla-extract/recipes/createRuntimeFn");
var toggleButton = (0, import_createRuntimeFn5.createRuntimeFn)({ defaultClassName: "dig-15yi6yl7_21-1-1", variantClassNames: { variant: { filled: "dig-15yi6yl8_21-1-1", outline: "dig-15yi6yl9_21-1-1", borderless: "dig-15yi6yla_21-1-1" }, boxShadow: { true: "dig-15yi6ylb_21-1-1", false: "dig-15yi6ylc_21-1-1" }, borderRadius: { xsmall: "dig-15yi6yl0_21-1-1", small: "dig-15yi6yl1_21-1-1", medium: "dig-15yi6yl2_21-1-1", large: "dig-15yi6yl3_21-1-1", xlarge: "dig-15yi6yl4_21-1-1", circular: "dig-15yi6yl5_21-1-1", false: "dig-15yi6yl6_21-1-1" } }, defaultVariants: { variant: "filled" }, compoundVariants: [] });

// ../src/buttons/toggle_button/toggle_button.tsx
var import_focus_visible6 = require("focus-visible");
var React10 = __toESM(require("react"));
var import_classnames7 = __toESM(require("classnames"));
var _excluded7 = ["className", "value", "isSelected", "shape", "variant", "size", "style", "withTextEnd", "fontFamily", "iconSrc", "onClick", "onSelection", "_pseudoClass"];
function _slicedToArray5(arr, i) {
  return _arrayWithHoles5(arr) || _iterableToArrayLimit5(arr, i) || _unsupportedIterableToArray5(arr, i) || _nonIterableRest5();
}
function _nonIterableRest5() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray5(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray5(o, minLen);
}
function _arrayLikeToArray5(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit5(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles5(arr) {
  if (Array.isArray(arr))
    return arr;
}
function _objectWithoutProperties7(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose7(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose7(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function getFontSize(props) {
  var font = props.font, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size;
  if (font === "Action") {
    return size === "xlarge" ? "Action Large" : getSizeString("Action", size);
  }
  return size === "xlarge" ? "Text Large" : getSizeString("Text", size);
}
function getButtonColors(props) {
  var variant = props.variant, isSelected = props.isSelected;
  switch (variant) {
    case "filled":
      if (isSelected) {
        return {
          // Filled is special -- we need to apply an opacity over Background Base
          // for the selected state
          backgroundOverlay: "Opacity Surface - State 2",
          hover: "Opacity Surface - State 1",
          active: "Opacity Surface - State 2"
        };
      } else {
        return {
          backgroundOverlay: "transparent",
          hover: "Opacity Surface",
          active: "Opacity Surface - State 1"
        };
      }
    case "borderless":
    case "outline":
      if (isSelected) {
        return {
          backgroundOverlay: "Opacity Surface - State 2",
          hover: "Opacity Surface - State 1",
          active: "Opacity Surface - State 2"
        };
      } else {
        return {
          backgroundOverlay: "transparent",
          hover: "Opacity Surface",
          active: "Opacity Surface - State 1"
        };
      }
  }
}
var ToggleButton = React10.forwardRef(function(_ref, ref) {
  var className = _ref.className, value = _ref.value, isSelectedProp = _ref.isSelected, shapeProp = _ref.shape, variantProp = _ref.variant, sizeProp = _ref.size, style = _ref.style, withTextEnd = _ref.withTextEnd, fontProp = _ref.fontFamily, iconSrc = _ref.iconSrc, onClick = _ref.onClick, onSelectionProp = _ref.onSelection, _pseudoClass = _ref._pseudoClass, rest = _objectWithoutProperties7(_ref, _excluded7);
  var _React$useState = React10.useState(isSelectedProp || false), _React$useState2 = _slicedToArray5(_React$useState, 2), internalSelectedState = _React$useState2[0], setInternalSelectedState = _React$useState2[1];
  var _React$useContext = React10.useContext(ToggleButtonContext), sizeContext = _React$useContext.size, shapeContext = _React$useContext.shape, selectedContext = _React$useContext.selected, variantContext = _React$useContext.variant, isInsideGroup = _React$useContext.isInsideGroup, onToggleClickContext = _React$useContext.onToggleClick, fontContext = _React$useContext.fontFamily;
  var variant = variantProp || variantContext;
  var size = sizeProp || sizeContext;
  var font = fontProp || fontContext || "Action";
  var shape = withTextEnd ? "standard" : shapeProp || shapeContext;
  var isSelected = isSelectedProp !== void 0 ? isSelectedProp : isInsideGroup ? selectedContext === null ? false : typeof selectedContext === "string" ? selectedContext === value : selectedContext.includes(value) : internalSelectedState;
  var colors = getButtonColors({
    isSelected: isSelected,
    variant: variant
  });
  var onClickHandler = function(evt) {
    if (isInsideGroup) {
      onToggleClickContext && onToggleClickContext({
        value: value,
        evt: evt
      });
    } else {
      onSelectionProp && onSelectionProp({
        isSelected: !internalSelectedState,
        evt: evt
      });
      setInternalSelectedState(!internalSelectedState);
    }
    onClick && onClick(evt);
  };
  var borderRadius = shape === "circular" ? shape : size === "xlarge" ? "large" : size;
  var toggleButton2 = /* @__PURE__ */ React10.createElement("button", __spreadValues(__spreadValues({ onClick: onClickHandler, ref: ref, type: "button", "aria-pressed": isSelected }, rest), (0, import_dig_foundations5.withShade)({
    direction: "up",
    className: (0, import_classnames7.default)(toggleButton({
      variant: variant,
      boxShadow: _pseudoClass === "focus",
      borderRadius: borderRadius
    }), className),
    style: style,
    bgColors: {
      base: colors.hover,
      active: colors.active
    },
    state: _pseudoClass
  })), /* @__PURE__ */ React10.createElement(InternalBox, { sx: {
    display: "flex",
    alignItems: "center",
    backgroundColor: colors.backgroundOverlay,
    padding: size === "xlarge" ? "Micro Medium" : size === "large" ? "Micro Small" : "Micro XSmall"
  } }, /* @__PURE__ */ React10.createElement(import_dig_icons4.UIIcon, { src: iconSrc, size: size === "small" ? "small" : "medium" }), withTextEnd && /* @__PURE__ */ React10.createElement(InternalBox, { sx: {
    paddingX: "Micro XSmall",
    fontFamily: font,
    letterSpacing: font === "Action" ? "Action" : void 0,
    fontSize: getFontSize({
      font: font,
      size: size
    }),
    fontWeight: font === "Action" ? "Strong" : "Base"
  } }, withTextEnd)));
  if (isInsideGroup) {
    return /* @__PURE__ */ React10.createElement(import_dig_foundations5.Cluster.Item, null, toggleButton2);
  } else {
    return toggleButton2;
  }
});
ToggleButton.displayName = "ToggleButton";

// ../src/buttons/toggle_button/toggle_button_group.tsx
var React11 = __toESM(require("react"));
var import_dig_foundations6 = require("@dropbox/dig-foundations");
var import_focus_visible7 = require("focus-visible");
var _excluded8 = ["children", "variant", "size", "shape", "selected", "exclusive", "onSelection", "fontFamily"];
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray6(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray6(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray6(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray6(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray6(arr);
}
function _arrayLikeToArray6(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}
function _objectWithoutProperties8(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose8(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose8(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var ToggleButtonGroup = function(_ref) {
  var children = _ref.children, variant = _ref.variant, size = _ref.size, shape = _ref.shape, selected = _ref.selected, exclusive = _ref.exclusive, onSelection = _ref.onSelection, fontFamily = _ref.fontFamily, splitProps = _objectWithoutProperties8(_ref, _excluded8);
  var handleToggleClick = function(props) {
    var value = props.value, evt = props.evt;
    if (exclusive === true) {
      var onSelectionExclusive = onSelection;
      onSelectionExclusive && onSelectionExclusive({
        value: selected === value ? null : value,
        evt: evt
      });
    } else {
      var selectedArray = selected === null ? [] : Array.isArray(selected) ? selected : [selected];
      var isSelected = selectedArray.includes(value);
      var onSelectionInclusive = onSelection;
      if (!isSelected) {
        onSelectionInclusive && onSelectionInclusive({
          value: [].concat(_toConsumableArray(selectedArray), [value]),
          evt: evt
        });
      } else {
        onSelectionInclusive && onSelectionInclusive({
          value: selectedArray.filter(function(v) {
            return v !== value;
          }),
          evt: evt
        });
      }
    }
  };
  return /* @__PURE__ */ React11.createElement(ToggleButtonContext.Provider, { value: {
    variant: variant,
    size: size || "medium",
    shape: shape || "standard",
    selected: selected,
    onToggleClick: handleToggleClick,
    isInsideGroup: true,
    fontFamily: fontFamily
  } }, /* @__PURE__ */ React11.createElement(import_dig_foundations6.Split, __spreadProps(__spreadValues({ wrap: "nowrap", alignY: "center", gap: "Micro XSmall" }, splitProps), { role: "group" }), children));
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Button,
  ButtonBar,
  IconButton,
  SplitButton,
  StylelessButton,
  ToggleButton,
  ToggleButtonGroup
});
